import useIntakeData from '../services/intakeDataService';
import { useMemo } from 'react';
import { ISelectOptions } from '../components/Inputs/Select';
import { SELECT_NONE_OPTION } from '../utils/noneOptionUtil';

export default function usePayorOptions(): ISelectOptions[] {
  const { data } = useIntakeData();
  const payorOptions = useMemo(
    () =>
      [
        SELECT_NONE_OPTION,
        ...(data?.payorOptions.map((payor) => ({
          ...payor,
          label: payor?.displayText,
        })) ?? []),
      ],
    [data?.payorOptions]
  );
  return payorOptions ?? [];
}
